import createIcon from '../../createIcon';

/**
 * @component @name GroupWork
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk04IDE3LjVDNi42MiAxNy41IDUuNSAxNi4zOCA1LjUgMTVDNS41IDEzLjYyIDYuNjIgMTIuNSA4IDEyLjVDOS4zOCAxMi41IDEwLjUgMTMuNjIgMTAuNSAxNUMxMC41IDE2LjM4IDkuMzggMTcuNSA4IDE3LjVaTTkuNSA4QzkuNSA2LjYyIDEwLjYyIDUuNSAxMiA1LjVDMTMuMzggNS41IDE0LjUgNi42MiAxNC41IDhDMTQuNSA5LjM4IDEzLjM4IDEwLjUgMTIgMTAuNUMxMC42MiAxMC41IDkuNSA5LjM4IDkuNSA4Wk0xNiAxNy41QzE0LjYyIDE3LjUgMTMuNSAxNi4zOCAxMy41IDE1QzEzLjUgMTMuNjIgMTQuNjIgMTIuNSAxNiAxMi41QzE3LjM4IDEyLjUgMTguNSAxMy42MiAxOC41IDE1QzE4LjUgMTYuMzggMTcuMzggMTcuNSAxNiAxNy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GroupWork = createIcon('GroupWork', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM8 17.5C6.62 17.5 5.5 16.38 5.5 15C5.5 13.62 6.62 12.5 8 12.5C9.38 12.5 10.5 13.62 10.5 15C10.5 16.38 9.38 17.5 8 17.5ZM9.5 8C9.5 6.62 10.62 5.5 12 5.5C13.38 5.5 14.5 6.62 14.5 8C14.5 9.38 13.38 10.5 12 10.5C10.62 10.5 9.5 9.38 9.5 8ZM16 17.5C14.62 17.5 13.5 16.38 13.5 15C13.5 13.62 14.62 12.5 16 12.5C17.38 12.5 18.5 13.62 18.5 15C18.5 16.38 17.38 17.5 16 17.5Z',
      key: '1uvgg8',
    },
  ],
]);

export default GroupWork;
